// extracted by mini-css-extract-plugin
export default {"container":"component_form_select_container__gv8Q+","checkboxGroup":"component_form_select_checkboxGroup__aWLDN"};